function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var _ref = /*#__PURE__*/React.createElement("path", {
  d: "M21.25 2.5H8.75A6.25 6.25 0 002.5 8.75v12.5a6.25 6.25 0 006.25 6.25h12.5a6.25 6.25 0 006.25-6.25V8.75a6.25 6.25 0 00-6.25-6.25z",
  stroke: "currentColor",
  strokeWidth: 2,
  strokeLinecap: "round",
  strokeLinejoin: "round"
});

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M20 14.212a5 5 0 11-9.891 1.467A5 5 0 0120 14.212z",
  stroke: "currentColor",
  strokeWidth: 2,
  strokeLinecap: "round",
  strokeLinejoin: "round"
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  d: "M21.875 8.125h.013",
  stroke: "currentColor",
  strokeWidth: 2,
  strokeLinecap: "round",
  strokeLinejoin: "round"
});

function SvgIcoInstagram(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    fill: "none"
  }, props), _ref, _ref2, _ref3);
}

export default "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMzAiIGhlaWdodD0iMzAiIHZpZXdCb3g9IjAgMCAzMCAzMCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPHBhdGggZD0iTTIxLjI1IDIuNUg4Ljc1QzUuMjk4MjIgMi41IDIuNSA1LjI5ODIyIDIuNSA4Ljc1VjIxLjI1QzIuNSAyNC43MDE4IDUuMjk4MjIgMjcuNSA4Ljc1IDI3LjVIMjEuMjVDMjQuNzAxOCAyNy41IDI3LjUgMjQuNzAxOCAyNy41IDIxLjI1VjguNzVDMjcuNSA1LjI5ODIyIDI0LjcwMTggMi41IDIxLjI1IDIuNVoiIHN0cm9rZT0iY3VycmVudENvbG9yIiBzdHJva2Utd2lkdGg9IjIiIHN0cm9rZS1saW5lY2FwPSJyb3VuZCIgc3Ryb2tlLWxpbmVqb2luPSJyb3VuZCIvPgo8cGF0aCBkPSJNMjAuMDAwMSAxNC4yMTI0QzIwLjE1NDQgMTUuMjUyNyAxOS45NzY3IDE2LjMxNTIgMTkuNDkyMyAxNy4yNDg3QzE5LjAwNzkgMTguMTgyMiAxOC4yNDE2IDE4LjkzOTIgMTcuMzAyMiAxOS40MTJDMTYuMzYyOCAxOS44ODQ4IDE1LjI5ODIgMjAuMDQ5NCAxNC4yNTk5IDE5Ljg4MjNDMTMuMjIxNSAxOS43MTUyIDEyLjI2MjMgMTkuMjI1IDExLjUxODcgMTguNDgxM0MxMC43NzUgMTcuNzM3NyAxMC4yODQ4IDE2Ljc3ODUgMTAuMTE3NyAxNS43NDAyQzkuOTUwNjMgMTQuNzAxOCAxMC4xMTUyIDEzLjYzNzMgMTAuNTg4IDEyLjY5NzlDMTEuMDYwOSAxMS43NTg1IDExLjgxNzkgMTAuOTkyMSAxMi43NTE0IDEwLjUwNzdDMTMuNjg0OSAxMC4wMjMzIDE0Ljc0NzMgOS44NDU2MiAxNS43ODc2IDkuOTk5ODlDMTYuODQ4OCAxMC4xNTcyIDE3LjgzMTIgMTAuNjUxNyAxOC41ODk3IDExLjQxMDNDMTkuMzQ4MyAxMi4xNjg4IDE5Ljg0MjggMTMuMTUxMiAyMC4wMDAxIDE0LjIxMjRaIiBzdHJva2U9ImN1cnJlbnRDb2xvciIgc3Ryb2tlLXdpZHRoPSIyIiBzdHJva2UtbGluZWNhcD0icm91bmQiIHN0cm9rZS1saW5lam9pbj0icm91bmQiLz4KPHBhdGggZD0iTTIxLjg3NSA4LjEyNUgyMS44ODgzIiBzdHJva2U9ImN1cnJlbnRDb2xvciIgc3Ryb2tlLXdpZHRoPSIyIiBzdHJva2UtbGluZWNhcD0icm91bmQiIHN0cm9rZS1saW5lam9pbj0icm91bmQiLz4KPC9zdmc+Cg==";
export { SvgIcoInstagram as ReactComponent };